import { Chip, Stack, Typography } from '@mui/material';
import { RefundStatus, StepStatus } from '@/models/subsidy/status';
import { DescriptionStep } from '@/packages/subsidy/pages/refund-request/components/step-wrapper';
import { useRefundRequest } from '@/packages/subsidy/pages/refund-request/context';
import { formatDate } from '@/utils/format-date';

interface DescriptionProps {
  statusMessage?: string;
  status: StepStatus | null;
  reason?: string;
}

const Description = ({ statusMessage, status, reason }: DescriptionProps) => {
  const isSuccess = status === StepStatus.Success;
  const showReason = !isSuccess && reason;

  return (
    <Stack spacing={2} alignItems="flex-start">
      {!isSuccess ? (
        <Chip label={statusMessage || ''} color={status || 'default'} />
      ) : (
        <Typography>{statusMessage}</Typography>
      )}
      {showReason && <Typography>{reason}</Typography>}
    </Stack>
  );
};

export const InvoiceValidation = () => {
  const { getStepState, resourceApproval, refundStatus } = useRefundRequest();
  const { status, disabled } = getStepState(4);

  const decisionDate = resourceApproval?.refund_request?.decided_at
    ? formatDate(resourceApproval.refund_request.decided_at)
    : '';

  const messages: Partial<Record<RefundStatus, string>> = {
    [RefundStatus.RefundRequestApproved]: `Pedido aprovado em ${decisionDate}`,
    [RefundStatus.RefundRequestPaid]: `Pedido aprovado em ${decisionDate}`,
    [RefundStatus.RefundRequestCanceled]: `Pedido cancelado em ${decisionDate}`,
    [RefundStatus.RefundRequestRejected]: `Pedido reprovado em ${decisionDate}`,
    [RefundStatus.RefundRequestRevisionRequired]: 'Correção necessária',
    [RefundStatus.RefundRequestPendingApproval]: 'Análise Galena pendente',
  };

  const statusMessage = refundStatus ? messages[refundStatus] : '';

  return (
    <DescriptionStep
      title="4. Validação dos comprovantes"
      stepStatus={status}
      disabled={disabled}
      description={
        <Description
          status={status}
          statusMessage={statusMessage}
          reason={resourceApproval?.refund_request?.decision_comment}
        />
      }
    />
  );
};
